var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 38,
    viewBox: "0 0 21 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 14.0087C6.96659 14.0087 7.07917 14.052 7.15711 14.1386L13.2192 20.2007C13.3924 20.3739 13.3924 20.6423 13.2192 20.8155L7.15711 26.8777C6.9839 27.0422 6.71544 27.0422 6.54224 26.869C6.37769 26.7045 6.37769 26.436 6.54224 26.2628L12.3012 20.5038L6.54224 14.7448C6.36903 14.5716 6.36903 14.3031 6.54224 14.1299C6.62018 14.052 6.73276 14 6.84534 14L6.854 14.0087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.fedaca6ec5256cd5ecd125855710942b.svg";
export { ForwardRef as ReactComponent };